import { render, staticRenderFns } from "./member_detail.vue?vue&type=template&id=33622220&scoped=true&"
import script from "./member_detail.vue?vue&type=script&lang=js&"
export * from "./member_detail.vue?vue&type=script&lang=js&"
import style0 from "./member_detail.vue?vue&type=style&index=0&id=33622220&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33622220",
  null
  
)

export default component.exports